import { Reveal } from "./Reveal";

interface SectionHeaderProps {
  numero: string;
  titre: string;
  intro?: string;
  align?: "left" | "center";
}

/** En-tête de section : numéro romain, ornements, titre en Playfair. */
export function SectionHeader({ numero, titre, intro, align = "center" }: SectionHeaderProps) {
  const centered = align === "center";
  return (
    <Reveal className={`mb-12 md:mb-16 ${centered ? "text-center" : "text-left"}`}>
      <div className={`flex items-center gap-4 ${centered ? "justify-center" : "justify-start"}`}>
        <span className="h-px w-10 bg-gradient-to-r from-transparent to-gold/70" aria-hidden />
        <span className="font-elegant text-sm tracking-[0.5em] text-gold/90 uppercase pl-2">
          {numero}
        </span>
        <span className="h-px w-10 bg-gradient-to-l from-transparent to-gold/70" aria-hidden />
      </div>
      <h2 className="mt-5 font-display text-3xl md:text-5xl font-semibold text-gold-gradient animate-shimmer leading-tight">
        {titre}
      </h2>
      {intro ? (
        <p className={`mt-5 max-w-3xl text-sm md:text-base leading-relaxed text-cream/75 ${centered ? "mx-auto" : ""}`}>
          {intro}
        </p>
      ) : null}
      <div className={`mt-7 flex items-center gap-3 ${centered ? "justify-center" : "justify-start"}`} aria-hidden>
        <span className="h-px w-16 bg-gold/30" />
        <svg width="14" height="14" viewBox="0 0 14 14" className="text-gold">
          <rect x="3.5" y="3.5" width="7" height="7" transform="rotate(45 7 7)" fill="currentColor" opacity="0.85" />
          <rect x="5.5" y="5.5" width="3" height="3" transform="rotate(45 7 7)" fill="#0e0a06" />
        </svg>
        <span className="h-px w-16 bg-gold/30" />
      </div>
    </Reveal>
  );
}
